import compose from 'recompose/compose'
import lifecycle from 'recompose/lifecycle'
import branch from 'recompose/branch'
import withHandlers from 'recompose/withHandlers'
import renderNothing from 'recompose/renderNothing'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import * as ClassificationSelectors from 'app/modules/classification/selectors'
import * as SegmentActions from 'app/modules/segment/actions'
import * as PlaybookActions from 'app/modules/playbook/actions'
import * as PlaybookSelectors from 'app/modules/playbook/selectors'
import { PlaybookViewConfig, PlaybookStatus } from 'app/modules/playbook/constants'
import * as MeetingActions from 'app/modules/meetings/actions'
import * as RulesActions from 'app/modules/rules/actions'
import * as EmbedActions from 'app/modules/embed/actions'

import Playbook from './component'

const mapStateToProps = state => ({
  draft: PlaybookSelectors.draft(state),
  isDraftEnabled: PlaybookSelectors.isEnabled(state),
  isAutosaveActive: PlaybookSelectors.isAutosaveActive(state),
  isStatusLoading: PlaybookSelectors.isStatusLoading(state),
  isSaved: PlaybookSelectors.isSaved(state),
  classifications: ClassificationSelectors.classifications(state),
  draftLoading: PlaybookSelectors.draftLoading(state),
  editSenderModalVisible: PlaybookSelectors.getEditSenderModalVisible(state),
  tokenModalVisible: PlaybookSelectors.getTokenModalVisible(state),
  goalRoutingModalVisible: PlaybookSelectors.getGoalRoutingModalVisible(state),
  goalActionModalVisible: PlaybookSelectors.getGoalActionModalVisible(state),
  sendEmailConfirmModalVisible: PlaybookSelectors.getSendEmailConfirmModalVisible(state),
  conditionModalVisible: PlaybookSelectors.getConditionModalVisible(state),
  answerModalVisible: PlaybookSelectors.getAnswerModalVisible(state),
  calendarLinkModalVisible: PlaybookSelectors.getCalendarLinkModalVisible(state),
  scheduleModalVisible: PlaybookSelectors.getScheduleModalVisible(state),
  ctaButtonModalVisible: PlaybookSelectors.getCtaButtonModalVisible(state),
  questionAdvancedModalVisible: PlaybookSelectors.getQuestionAdvancedModalVisible(state),
  extensionInviteModalVisible: PlaybookSelectors.getExtensionInviteModalVisible(state),
  sequenceInviteModalVisible: PlaybookSelectors.sequenceInviteModalVisible(state),
  isLeadBot: PlaybookSelectors.isLeadBot(state),
  isSequencePlaybook: PlaybookSelectors.getIsSequencePlaybook(state),
  isSignaturePlaybook: PlaybookSelectors.isSignaturePlaybook(state),
  isEmailPlaybook: PlaybookSelectors.getIsEmailPlaybook(state),
  reportType: PlaybookSelectors.reportType(state),
  isOneTimeEmailPlaybook: PlaybookSelectors.getIsOneTimeEmailPlaybook(state),
  isOneTimeMarketingSequencePlaybook: PlaybookSelectors.getIsOneTimeMarketingSequencePlaybook(state),
  isOutboundPlaybook: PlaybookSelectors.isOutboundPlaybook(state),
  googleAuthModalVisible: PlaybookSelectors.getGoogleAuthModalVisible(state),
  disableSalesSequenceModalVisible: PlaybookSelectors.getDisableSalesSequenceModalVisible(state),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      clearDraft: PlaybookActions.clearDraft,
      setName: PlaybookActions.setName,
      fetchRules: RulesActions.fetchRules,
      fetchConnectedCalendars: MeetingActions.fetchConnectedCalendars,
      fetchSegmentList: SegmentActions.fetchSegmentList,
      fetchEmbed: EmbedActions.fetchEmbed,
      enablePlaybookAutosave: PlaybookActions.enablePlaybookAutosave,
      disablePlaybookAutosave: PlaybookActions.disablePlaybookAutosave,
      setDraftStatus: PlaybookActions.setDraftStatus,
    },
    dispatch
  ),
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  branch(({ draftLoading, classifications }) => draftLoading || !classifications, renderNothing),
  withHandlers({
    onNameChange: props => event => {
      props.actions.setName(event.target.value)
    },
    onExitAttempt: props => nextRoute => {
      if (!nextRoute) return true // this may not always return a route, TODO: debug - pk2
      const { isSaved } = props
      const { pathname } = nextRoute
      if (!isSaved && !/^\/playbooks\/\d+/.test(pathname)) {
        return 'You have unsaved changes in your playbook. Would you like to exit without saving?'
      }
      return true
    },
    onUnload: props => event => {
      const { isSaved } = props
      if (!isSaved) {
        event.returnValue = true
      }
    }
  }),
  lifecycle({
    componentWillMount() {
      const {
        router,
        reportType,
        location,
        draft,
        isLeadBot,
        isSequencePlaybook,
        isSignaturePlaybook,
        actions: { fetchRules, fetchConnectedCalendars, fetchSegmentList, fetchEmbed, enablePlaybookAutosave, disablePlaybookAutosave },
      } = this.props
      fetchRules()
      fetchConnectedCalendars()
      fetchSegmentList()
      fetchEmbed()

      const { status } = draft

      const playbooksPath = `/playbooks/${draft.id}/edit`
      const viewConfig = PlaybookViewConfig[reportType] || {}
      if (status === PlaybookStatus.DISABLED) {
        enablePlaybookAutosave()
      } else {
        disablePlaybookAutosave()
      }

      if (location.pathname === playbooksPath) {
        if (isLeadBot) {
          router.replace(`${playbooksPath}/leadbot`)
        } else if (isSignaturePlaybook) {
          router.replace(`${playbooksPath}/message/signature`)
        } else if (isSequencePlaybook) {
          router.replace(`${playbooksPath}/sequence`)
        } else if (viewConfig && viewConfig.messageUrlPath) {
          router.replace(`${playbooksPath}/message/${viewConfig.messageUrlPath}`)
        }
      }

    },
    componentDidMount() {
      const { router, route, onExitAttempt, onUnload } = this.props
      router.setRouteLeaveHook(route, onExitAttempt)
      window.addEventListener('beforeunload', onUnload)
    },
    componentWillUnmount() {
      this.props.actions.clearDraft()
      window.removeEventListener('beforeunload', this.props.onUnload)
    },
  })
)(Playbook)



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/Playbook/index.js